export default "__VITE_ASSET__2fad2580__"